import React from 'react';
import { withStyles, Grid, CircularProgress } from '@material-ui/core';
import { withRouter } from "react-router-dom"
import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';
import { NewsItem } from './view';
import { ListView } from 'antd-mobile';
import ToName from '../../control/ToName';
import AppData from '../../model/AppData';


const ICON_GIF = require("../../images/bg/ballLoad.gif");
class HomeNews extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newsList: [],
            isRequire: false,
            pageSize: 20,
            pageNum: 1,
            totalPage: 0,
        }
    }


    componentDidMount() {
        AppUtils.YMPush('MAIN', 'HomeNews');
        this.getNewsList(true);
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getNewsList = async (isRequire = false) => {
        const { pageSize, pageNum, newsList } = this.state;
        this.setState({ isRequire: isRequire });
        let result = await Apis.encryptionQiutxNews(pageSize, pageNum);
        if (result.code == 200) {

            if (result.data && result.data.list.length > 0) {
                let list = result.data.list;
                for (let i = 0; i < list.length; i++) {
                    let item = list[i];
                    let _time = item.createdDate
                    item.createdDate = _time.substring(0, _time.length - 3);
                    newsList.push(item)
                }

                this.setState({ newsList: newsList, totalPage: result.data.totalPage });
            }
        }
        this.setState({ isRequire: false });
    }

    _onClickNews = (data) => {
        let os =  0;
        if (AppData.os != 0 && AppData.os != '') {
            os = AppData.os
        }
        ToName(this.props, `/newsdetail/${data.id}/${os}`)
    }

    _onEndReached = () => {
        const { pageNum, totalPage } = this.state;
        let pageNow = pageNum + 1;

        console.log('_onEndReached', pageNow, totalPage);

        if (pageNow < totalPage) {
            this.setState({ pageNum: pageNow }, () => {
                this.getNewsList();
            })
        }
    }

    _renderHeader = () => {
        return (<Grid style={{ height: 12 }}></Grid>);
    }

    _renderItem = (data) => {
        const { classes } = this.props;
        return (
            <Grid container style={{ width: '100vm', overflow: 'hidden',paddingRight:10 }} >
                <div className={classes.itemView} onClick={() => this._onClickNews(data)} >

                    <div className={classes.itemColumn} >
                        <div className={classes.title}>{data.title}</div>
                        <div className={classes.time}>{data.createdDate}</div>
                    </div>
                    <img style={{ borderRadius: 10, height: 70, width: 95, objectFit: 'cover' }} src={data.imgUrl} />


                </div>
            </Grid>

        );
    }

    _renderFooter = () => {
        return (<Grid style={{ height: 48 }}></Grid>);
    }

    render() {
        const { classes } = this.props;
        const { newsList, isRequire } = this.state;
        let data = newsList;
        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        if (!isRequire) {
            return <div className={classes.list}>
                <ListView
                    initialListSize={data.length}
                    style={{ width: '100%', maxWidth: '100%', height: '100%' }}
                    contentContainerStyle={{ width: '100%' }}
                    dataSource={ds.cloneWithRows(data)}
                    renderHeader={this._renderHeader}
                    renderFooter={this._renderFooter}
                    renderRow={this._renderItem}
                    onEndReached={this._onEndReached}
                    pageSize={6}
                    useBodyScroll={false}
                    onEndReachedThreshold={0.5}
                />
                {/* {newsList.map((item,i)=>(
                    this._renderItem(item)
                ))} */}

            </div>
        }
        return <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
            < img src={ICON_GIF} style={{ width: 280, height: 280, marginTop: 150, objectFit: 'scale-down' }}></img>
            {/* <Typography style={{ fontSize: 12, color: '#878787', }} >赛事正在加载中...</Typography> */}
        </div>

    }

}

export default withRouter(withStyles((theme) => ({
    title: {
        color: '#0D0D0D',
        fontSize: 14,
    },
    time: {
        color: '#919191',
        fontSize: 10,
        marginTop: 10,
    },
    itemColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: '70%'

    },
    itemView: {
        width: '100%',
        marginBottom: 7,
        marginLeft: 10,
        backgroundColor: '#fff',
        borderRadius: 10,
        display: 'flex',
        justifyContent: 'space-between',
        padding: 10
    },
    list: {
        margin: theme.spacing(0),
        padding: theme.spacing(0),
        height: '100%',
    },
}))(HomeNews));